// Константы маршрутов - вынесены отдельно для избежания циклических импортов
export const ROUTES = {
    MAINTENANCE: {name: 'Maintenance', path: '/maintenance'},
    HOME: {name: 'homePage', path: '/'},
    REGISTRATION: {name: 'registrationPage', path: '/registration'},
    LOGIN: {name: 'loginPage', path: '/login'},
    RESTORE_PASSWORD: {name: 'RestorePasswordPage', path: '/restore-password'},
    RESET_PASSWORD: {name: 'ResetPasswordPage', path: '/auth/reset-password'},
    USER: {name: 'UserPage', path: '/user/:id'},
    CREATE_AD: {name: 'CreateAdPage', path: '/create-ad'},
    VACANCIES: {name: 'VacancyPage', path: '/vacancy'},
    VACANCY_CREATE: {name: 'vacancy_editor', path: '/vacancy/editor'},
    VACANCY_EDITOR_EDIT: {name: 'vacancy_editor_edit', path: '/vacancy/editor/:id'},
    VACANCY_DETAIL: {name: 'vacancy_id', path: '/vacancy/:id'},
    RESUMES: {name: 'ResumePage', path: '/resume'},
    RESUME_CREATE: {name: 'resume_editor', path: '/resume/editor'},
    RESUME_EDITOR_EDIT: {name: 'resume_editor_edit', path: '/resume/editor/:id'},
    RESUME_DETAIL: {name: 'resume_id', path: '/resume/:id'},
    OFFERINGS: {name: 'OfferingsPage', path: '/offering'},
    PRODUCTS: {name: 'ProductsPage', path: '/product'},
    OFFERING_DETAIL: {name: 'OfferingPage', path: '/offering/:id'},
    PRODUCT_DETAIL: {name: 'ProductPage', path: '/product/:id'},
    OFFERING_CREATE: {name: 'OfferingEditorPage', path: '/offering/editor'},
    PRODUCT_CREATE: {name: 'ProductEditorPage', path: '/product/editor'},
    OFFERING_EDITOR_EDIT: {name: 'offering_editor_edit', path: '/offering/editor/:id'},
    PRODUCT_EDITOR_EDIT: {name: 'product_editor_edit', path: '/product/editor/:id'},
    PROFILE: {name: 'ProfilePage', path: '/profile'},
    FAVORITES: {name: 'FavoritesPage', path: '/profile/favorites'},
    PROFILE_SETTINGS: {name: 'ProfileSettingsPage', path: '/profile/settings'},
    PROFILE_CHANGE_PASSWORD: {name: 'ProfileChangePasswordPage', path: '/profile/change-password'},
    PROFILE_FAVORITES: {name: 'ProfileFavoritesPage', path: '/profile/favorites'},
    PROFILE_CHAT: {name: 'ChatPage', path: '/profile/chat'},
    PROFILE_CHAT_DETAIL: {name: 'ChatDetailPage', path: '/profile/chat/:id'},
    PROFILE_ORDERS: {name: 'OrdersPage', path: '/profile/orders'},
    REFERRAL: {name: 'ReferralPage', path: '/profile/referral'},
    CONFIRM_EMAIL: {name: 'confirmEmail', path: '/auth/confirm'},
    SEARCH: {name: 'Search', path: '/search'},
    MODERATION: {name: 'ModerationPage', path: '/moderation'},
    MESSENGERS: {name: 'MessengerPage', path: '/messenger'},
    MESSENGER_CREATE: {name: 'messenger_editor', path: '/messenger/editor'},
    MESSENGER_EDITOR_EDIT: {name: 'messenger_editor_edit', path: '/messenger/editor/:id'},
    MESSENGER_DETAIL: {name: 'messenger_id', path: '/messenger/:id'},
    REALTY: {name: 'RealtyPage', path: '/realty'},
    REALTY_DETAIL: {name: 'RealtyDetailPage', path: '/realty/:id'},
    REALTY_CREATE: {name: 'RealtyEditorPage', path: '/realty/editor'},
    REALTY_EDITOR_EDIT: {name: 'realty_editor_edit', path: '/realty/editor/:id'},
    QUICK_ANNOUNCEMENTS: {name: 'QuickAnnouncementsPage', path: '/quick_announcement'},
    QUICK_ANNOUNCEMENT_CREATE: {name: 'quick_announcement_editor', path: '/quick_announcement/editor'},
    QUICK_ANNOUNCEMENT_EDITOR_EDIT: {name: 'quick_announcement_editor_edit', path: '/quick_announcement/editor/:id'},
    QUICK_POST_LIST: {name: 'QuickPostList', path: '/quick-posts'},
    QUICK_POST_DETAIL: {name: 'QuickPostDetail', path: '/quick-posts/:id'},
    QUICK_POST_CREATE: {name: 'QuickPostCreate', path: '/quick-posts/create'},
    QUICK_POST_EDIT: {name: 'QuickPostEdit', path: '/quick-posts/:id/edit'},
    QUICK_POST_MY: {name: 'QuickPostMy', path: '/profile/quick-posts'},
    USER_NOTIFICATION: {name: 'UserNotificationPage', path: '/user_notification'},
    NEWS: {name: 'NewsPage', path: '/news'},
    NEWS_DETAIL: {name: 'NewsDetailPage', path: '/news/:id'},
    RULES: {name: 'RulesPage', path: '/rules'},
    GROUPS: {name: 'GroupsPage', path: '/groups'},
    GROUPS_DETAIL: {name: 'GroupDetailPage', path: '/groups/:id'},
    ONBOARDING: {name: 'OnboardingPage', path: '/onboarding'},
    PROFILE_MY_LISTINGS: {name: 'MyListingsPage', path: '/profile/listings'},
    PROFILE_MY_PRODUCTS: {name: 'MyProductsPage', path: '/profile/products'},
    FAVORITES_FOLDER: {name: 'FolderPage', path: '/profile/favorites/folder/:id'},
    SUPPORT: {name: 'SupportChatPage', path: '/support'},
};
